module.exports = __webpack_public_path__ + "img/symbol_8.a534b6e5.png";